export const toggleScroll = (state: boolean): void => {
  const bodyEl = document.getElementsByTagName("body")[0];
  if (!state) {
    bodyEl.classList.add("overflow-hidden");
  } else {
    bodyEl.classList.remove("overflow-hidden");
  }
};
